import React from 'react';
import { Link } from 'react-router-dom';
import GenericQuiz from '../components/GenericQuiz';
import { resistorsQuizData } from '../data/resistors';

const ResistorsPage = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-6 sm:mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-blue-600 hover:text-blue-700 transition-colors text-sm sm:text-base mb-4 touch-manipulation"
          >
            ← Back to Home
          </Link>
        </div>
        
        <GenericQuiz quiz={resistorsQuizData} />
      </div>
    </div>
  );
};

export default ResistorsPage;